type BusinessGroupNameValidationItem = {
  name: string;
};

export const normalizeBusinessGroupName = (name: string) =>
  name.trim().normalize("NFKC").toLocaleLowerCase();

export const hasDuplicateBusinessGroupName = ({
  existingBusinessGroups,
  businessGroupName,
}: {
  existingBusinessGroups: BusinessGroupNameValidationItem[];
  businessGroupName: string;
}) => {
  const normalizedBusinessGroupName = normalizeBusinessGroupName(businessGroupName);
  if (!normalizedBusinessGroupName) {
    return false;
  }

  return existingBusinessGroups.some(
    (businessGroup) =>
      normalizeBusinessGroupName(businessGroup.name) === normalizedBusinessGroupName,
  );
};
